import { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import FloatingButtons from "./FloatingButtons";
import ExitPopup from "./ExitPopup";
import { Toaster } from "sonner";

const Layout = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);

    return (
        <div className="min-h-screen bg-samora-bone text-samora-text font-sans">
            <Header />
            <main data-testid="page-main" className="pt-0">
                <Outlet />
            </main>
            <Footer />
            <FloatingButtons />
            <ExitPopup />
            <Toaster
                position="bottom-center"
                richColors
                toastOptions={{
                    style: {
                        borderRadius: 0,
                        border: "1px solid #E4DED4",
                        fontFamily: "Inter, sans-serif",
                    },
                }}
            />
        </div>
    );
};

export default Layout;
